import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6ubkgarv: FaireBrandEntity = {
  token: "b_6ubkgarv",
  type: "brand",
  name: "Newcastle Classics",
  avatarUrl:
    "https://cdn.faire.com/fastly/c9f2f689893f127d01e7b09b4ca5a8957b681a2b4e20f098e0ce57b6e2a6ed7b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/5fc9b0952be9ab4527220a45280c6118b0a2f78c0f79043d3dddaa8ba85c1c4b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c9f2f689893f127d01e7b09b4ca5a8957b681a2b4e20f098e0ce57b6e2a6ed7b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5fc9b0952be9ab4527220a45280c6118b0a2f78c0f79043d3dddaa8ba85c1c4b.jpeg",
  location: "Newcastle, CA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 743,
  isTopShop: true,
  isInsider: true,
  description:
    "Newcastle Classics a boutique exclusive brand. Featuring timeless swaddles, blankets, bibs, and towels for kids and baby, featuring soft and durable cotton and bamboo muslin fabrics. Our goal is to provide timeless designs for a more modern mom, with elevated packaging, as well as competitive prices. Our company was started by a mother of two boys who wanted to create products with classic prints that would blend well with her everyday style.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:41.822Z",
    importedBy: "entity-db-cli",
  },
};
